import React, { ReactNode } from "react";
import { Box, CircularProgress } from "@mui/material";

export interface FormFrameProps {
  loading?: boolean;
  children: ReactNode;
}

const FormFrame = ({ loading = false, children }: FormFrameProps) => {
  return (
    <React.Fragment>
      <Box
        sx={{
          overflow: "hidden",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
          p: 2,
          position: "relative",
          bgcolor: "white",
        }}
      >
        {children}
      </Box>
      {loading && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "center",
            zIndex: 1000,
            backdropFilter: "blur(2px)",
          }}
        >
          <CircularProgress color="primary" size={100} sx={{ mt: 44 }} />
        </Box>
      )}
    </React.Fragment>
  );
};

export default FormFrame;
